(function(){
  "use strict";
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasGSAP = !!window.gsap;
  var hasST = hasGSAP && !!window.ScrollTrigger;
  var hasSplit = hasGSAP && !!window.SplitText;
  if(hasST) gsap.registerPlugin(ScrollTrigger);
  if(hasSplit) gsap.registerPlugin(SplitText);
  var DPR = Math.min(window.devicePixelRatio || 1, 2);

  /* hide hero pieces only when GSAP can bring them back */
  if(hasGSAP && !RM){
    gsap.set('#hero .ll',{yPercent:112});
    gsap.set('[data-hero]',{opacity:0,y:20});
    gsap.set('.hero-stage',{opacity:0,y:26});
  }

  /* ---------- PRELOADER (under 2.5s) ---------- */
  var pre = document.getElementById('preloader');
  var plBar = document.getElementById('plBar');
  var plRead = document.getElementById('plRead');
  var plShelf = document.getElementById('plShelf');
  var preDone = false;
  function endPreload(){
    if(preDone) return; preDone = true;
    if(!pre){ heroIntro(); return; }
    if(hasGSAP && !RM){
      gsap.delayedCall(.2, heroIntro);
      gsap.to(pre,{opacity:0,duration:.7,ease:'power2.inOut',onComplete:function(){pre.style.display='none';}});
    } else {
      pre.style.display='none'; heroIntro();
    }
  }
  (function runPreload(){
    if(RM || !hasGSAP){ if(plBar) plBar.style.transform='scaleX(1)'; setTimeout(endPreload,260); return; }
    var bars = plShelf ? plShelf.querySelectorAll('i') : [];
    if(bars.length) gsap.to(bars,{scaleY:1,duration:.5,ease:'power2.out',stagger:{each:.06,from:'start'}});
    var o={v:0};
    gsap.to(o,{v:1,duration:1.6,ease:'power2.inOut',
      onUpdate:function(){
        if(plBar) plBar.style.transform='scaleX('+o.v.toFixed(3)+')';
        if(plRead){ var d=Math.round(o.v*4000); plRead.textContent=('0000'+d).slice(-4)+' M / OPENING THE VAULT'; }
      },
      onComplete:endPreload});
  })();
  setTimeout(endPreload, 2500); // failsafe, the store never stays behind the curtain

  /* ---------- LENIS (single instance) ---------- */
  var lenis = null;
  if(window.Lenis && !RM){
    lenis = new Lenis({duration:1.4,easing:function(t){return Math.min(1,1.001-Math.pow(2,-10*t));},smoothWheel:true});
    if(hasST){
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function(t){ lenis.raf(t*1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      var raf=function(t){ lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    }
    lenis.on('scroll', onScroll);
  }
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var id=a.getAttribute('href'); if(!id || id.length<2) return;
      var el=document.querySelector(id); if(!el) return;
      e.preventDefault();
      if(lenis) lenis.scrollTo(el,{offset:-70,duration:1.8});
      else el.scrollIntoView({behavior:'smooth'});
    });
  });

  /* ---------- SCROLL INSTRUMENTS ---------- */
  var nav=document.getElementById('nav'), prog=document.getElementById('progress'),
      bgDeep=document.getElementById('bgDeep'), navDepth=document.getElementById('navDepth'),
      caust=document.querySelector('.caustics');
  var lastP=-1, lastSt=0, scrollVel={v:0};
  function onScroll(){
    var st=window.pageYOffset || document.documentElement.scrollTop || 0;
    scrollVel.v=Math.max(-600,Math.min(600,scrollVel.v+(st-lastSt))); lastSt=st;
    var h=document.documentElement.scrollHeight-window.innerHeight;
    var p=h>0?Math.min(1,Math.max(0,st/h)):0;
    if(nav){ if(st>30) nav.classList.add('scrolled'); else nav.classList.remove('scrolled'); }
    if(Math.abs(p-lastP)<0.0008) return; lastP=p;
    if(prog) prog.style.transform='scaleX('+p.toFixed(4)+')';
    if(bgDeep) bgDeep.style.opacity=Math.min(1,p*1.25).toFixed(3);
    if(caust) caust.style.opacity=Math.max(0,1-p*2.2).toFixed(3);
    if(navDepth) navDepth.textContent=('0000'+Math.round(p*4000)).slice(-4)+' M';
  }
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){ lastP=-1; onScroll(); });
  onScroll();

  /* ---------- BACKGROUND WATER COLUMN (marine snow + motes) ---------- */
  (function column(){
    var cv=document.getElementById('snowCanvas');
    if(!cv || RM){ if(cv) cv.style.display='none'; return; }
    var ctx=cv.getContext('2d'); if(!ctx){ cv.style.display='none'; return; }
    var W=0,H=0,snow=[],motes=[],running=true;
    function resize(){
      W=cv.width=Math.round(innerWidth*DPR); H=cv.height=Math.round(innerHeight*DPR);
    }
    resize(); addEventListener('resize',resize);
    var NS=Math.min(70,Math.round(innerWidth/22));
    for(var i=0;i<NS;i++) snow.push({x:Math.random()*W,y:Math.random()*H,r:(Math.random()*.9+.35)*DPR,
      vy:(Math.random()*.12+.05)*DPR,dx:Math.random()*6.283,a:Math.random()*.14+.05,dep:Math.random()*.8+.2});
    var NM=Math.min(52,Math.round(innerWidth/28));
    for(i=0;i<NM;i++) motes.push({x:Math.random()*W,y:Math.random()*H,r:(Math.random()*1.7+.4)*DPR,
      vy:-(Math.random()*.16+.04)*DPR,vx:(Math.random()-.5)*.05*DPR,a:Math.random()*.5+.15,
      tw:Math.random()*6.283,dep:Math.random()*.7+.3});
    document.addEventListener('visibilitychange',function(){ running=!document.hidden; });
    var sm=0;
    (function frame(){
      requestAnimationFrame(frame);
      if(!running) return;
      sm+=(scrollVel.v-sm)*.06; scrollVel.v*=.9;
      var cam=sm*.04*DPR;
      ctx.clearRect(0,0,W,H);
      var depthMix=Math.max(0,Math.min(1,lastP));
      ctx.fillStyle='rgba(178,208,228,1)';
      for(var i=0;i<snow.length;i++){ var s=snow[i];
        s.dx+=.006; s.y+=s.vy-cam*s.dep; s.x+=Math.sin(s.dx)*.12*DPR;
        if(s.y>H+10){ s.y=-8; s.x=Math.random()*W; }
        if(s.y<-12){ s.y=H+8; s.x=Math.random()*W; }
        ctx.globalAlpha=s.a*(.3+depthMix*.85);
        ctx.beginPath(); ctx.arc(s.x,s.y,s.r,0,6.283); ctx.fill();
      }
      ctx.globalAlpha=1;
      var glow=Math.min(1,depthMix*1.25+.28);
      for(i=0;i<motes.length;i++){ var m=motes[i];
        m.y+=m.vy-cam*m.dep; m.x+=m.vx; m.tw+=.02+Math.min(.02,Math.abs(sm)*.0006);
        if(m.y<-12){ m.y=H+10; m.x=Math.random()*W; }
        if(m.y>H+14){ m.y=-10; m.x=Math.random()*W; }
        var al=m.a*glow*(.6+.4*Math.sin(m.tw));
        var g=ctx.createRadialGradient(m.x,m.y,0,m.x,m.y,m.r*4);
        g.addColorStop(0,'rgba(143,247,255,'+al.toFixed(3)+')');
        g.addColorStop(.4,'rgba(73,232,214,'+(al*.5).toFixed(3)+')');
        g.addColorStop(1,'rgba(73,232,214,0)');
        ctx.fillStyle=g; ctx.beginPath(); ctx.arc(m.x,m.y,m.r*4,0,6.283); ctx.fill();
      }
    })();
  })();

  /* ---------- HERO SOUNDING WELL, live-bound sim ---------- */
  (function sounding(){
    var cv=document.getElementById('heroCanvas'), stage=document.getElementById('heroStage');
    if(!cv || !stage) return;
    var ctx=cv.getContext('2d'); if(!ctx) return;
    var rdDepth=document.getElementById('rdDepth'), rdPress=document.getElementById('rdPress'),
        rdTemp=document.getElementById('rdTemp'), rdReturns=document.getElementById('rdReturns'),
        rdSweep=document.getElementById('rdSweep');
    var W=0,H=0,flakes=[],echoes=[],rings=[],visible=false,started=false;
    var sweepP=0, sweepNo=1, returns=0, px=.5, py=.42, cxp=.5, cyp=.42, hovering=false, tick=0;
    function size(){
      var r=cv.getBoundingClientRect();
      W=cv.width=Math.max(2,Math.round(r.width*DPR));
      H=cv.height=Math.max(2,Math.round(r.height*DPR));
    }
    function seed(){
      flakes.length=0;
      var n=Math.min(90,Math.round((W*H)/(24000*DPR)));
      for(var i=0;i<n;i++) flakes.push({x:Math.random(),y:Math.random(),r:Math.random()*1.5+.4,
        v:Math.random()*.0009+.0003,d:Math.random()*.7+.3,a:Math.random()*.4+.12});
      echoes.length=0;
      var spots=[[.24,.2],[.72,.31],[.38,.48],[.8,.6],[.2,.72],[.58,.84]];
      for(i=0;i<spots.length;i++) echoes.push({x:spots[i][0],y:spots[i][1],flash:0,seen:false});
      rings.length=0;
    }
    function statics(){
      if(rdDepth) rdDepth.textContent='0000 m';
      if(rdPress) rdPress.textContent='001.0 bar';
      if(rdTemp) rdTemp.textContent='14.0 °C';
      if(rdReturns) rdReturns.textContent='006';
      if(rdSweep) rdSweep.textContent='001';
    }
    function draw(){
      ctx.clearRect(0,0,W,H);
      var g=ctx.createLinearGradient(0,0,0,H);
      g.addColorStop(0,'rgba(12,41,71,.9)'); g.addColorStop(.55,'rgba(3,16,30,.95)'); g.addColorStop(1,'rgba(0,4,10,1)');
      ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
      // depth rules
      ctx.strokeStyle='rgba(120,180,210,.09)'; ctx.lineWidth=1*DPR;
      for(var k=1;k<8;k++){ var yy=Math.round(H*k/8)+.5; ctx.beginPath(); ctx.moveTo(0,yy); ctx.lineTo(W,yy); ctx.stroke(); }
      // pointer light
      var lx=cxp*W, ly=cyp*H, lr=Math.min(W,H)*.55;
      var lg=ctx.createRadialGradient(lx,ly,0,lx,ly,lr);
      lg.addColorStop(0,'rgba(160,240,255,.16)'); lg.addColorStop(.4,'rgba(73,232,214,.07)'); lg.addColorStop(1,'rgba(73,232,214,0)');
      ctx.globalCompositeOperation='lighter'; ctx.fillStyle=lg; ctx.fillRect(0,0,W,H);
      // marine snow inside the well
      for(var i=0;i<flakes.length;i++){ var f=flakes[i];
        ctx.globalAlpha=f.a*(.4+.6*f.d);
        ctx.fillStyle='rgba(178,214,235,1)';
        ctx.beginPath(); ctx.arc(f.x*W,f.y*H,f.r*DPR,0,6.283); ctx.fill();
      }
      ctx.globalAlpha=1;
      // echoes
      for(i=0;i<echoes.length;i++){ var e=echoes[i];
        var ex=e.x*W, ey=e.y*H, base=e.seen?.28:.12;
        var eg=ctx.createRadialGradient(ex,ey,0,ex,ey,(9+e.flash*26)*DPR);
        var al=base+e.flash*.75;
        eg.addColorStop(0,'rgba(201,255,230,'+al.toFixed(3)+')');
        eg.addColorStop(.45,'rgba(73,232,214,'+(al*.4).toFixed(3)+')');
        eg.addColorStop(1,'rgba(73,232,214,0)');
        ctx.fillStyle=eg; ctx.beginPath(); ctx.arc(ex,ey,(9+e.flash*26)*DPR,0,6.283); ctx.fill();
      }
      // expanding returns
      for(i=rings.length-1;i>=0;i--){ var r2=rings[i];
        ctx.strokeStyle='rgba(143,247,255,'+(r2.life*.5).toFixed(3)+')';
        ctx.lineWidth=1.2*DPR;
        ctx.beginPath(); ctx.arc(r2.x*W,r2.y*H,r2.r*DPR,0,6.283); ctx.stroke();
      }
      // sweep line
      var sy=sweepP*H;
      var sg=ctx.createLinearGradient(0,sy-26*DPR,0,sy+26*DPR);
      sg.addColorStop(0,'rgba(73,232,214,0)'); sg.addColorStop(.5,'rgba(143,247,255,.5)'); sg.addColorStop(1,'rgba(73,232,214,0)');
      ctx.fillStyle=sg; ctx.fillRect(0,sy-26*DPR,W,52*DPR);
      ctx.strokeStyle='rgba(201,255,230,.85)'; ctx.lineWidth=1.4*DPR;
      ctx.beginPath(); ctx.moveTo(0,sy); ctx.lineTo(W,sy); ctx.stroke();
      ctx.globalCompositeOperation='source-over';
      // edge column marks
      ctx.fillStyle='rgba(73,232,214,.55)';
      ctx.fillRect(0,sy-1*DPR,14*DPR,2*DPR);
      ctx.fillRect(W-14*DPR,sy-1*DPR,14*DPR,2*DPR);
    }
    function step(){
      tick++;
      cxp+=((hovering?px:.5+Math.cos(tick*.006)*.22)-cxp)*.05;
      cyp+=((hovering?py:.42+Math.sin(tick*.005)*.2)-cyp)*.05;
      var prev=sweepP;
      sweepP+=.0022;
      if(sweepP>1){ sweepP=0; sweepNo++; for(var q=0;q<echoes.length;q++) echoes[q].flash=0; }
      for(var i=0;i<echoes.length;i++){ var e=echoes[i];
        if(prev<e.y && sweepP>=e.y && sweepP>prev){
          e.flash=1; returns++;
          if(!e.seen) e.seen=true;
          rings.push({x:e.x,y:e.y,r:6,vr:1.5,life:1});
        }
        if(e.flash>0) e.flash=Math.max(0,e.flash-.012);
      }
      for(i=rings.length-1;i>=0;i--){ var r2=rings[i]; r2.r+=r2.vr; r2.life-=.012; if(r2.life<=0) rings.splice(i,1); }
      for(i=0;i<flakes.length;i++){ var f=flakes[i]; f.y+=f.v*f.d*3; if(f.y>1.02){ f.y=-.02; f.x=Math.random(); } }
      draw();
      if(tick%5===0){
        var depth=Math.round(sweepP*4000);
        if(rdDepth) rdDepth.textContent=('0000'+depth).slice(-4)+' m';
        if(rdPress) rdPress.textContent=('00'+(depth/9.8+1).toFixed(1)).slice(-5)+' bar';
        if(rdTemp) rdTemp.textContent=(14-(depth/4000)*12).toFixed(1)+' °C';
        if(rdReturns) rdReturns.textContent=('000'+returns).slice(-3);
        if(rdSweep) rdSweep.textContent=('000'+sweepNo).slice(-3);
      }
    }
    function loop(){ requestAnimationFrame(loop); if(!visible || document.hidden) return; step(); }
    function boot(){
      if(started) return; started=true;
      size(); seed();
      if(RM){ draw(); statics(); return; }
      loop();
    }
    stage.addEventListener('pointermove',function(ev){
      var r=stage.getBoundingClientRect();
      px=(ev.clientX-r.left)/r.width; py=(ev.clientY-r.top)/r.height; hovering=true;
    });
    stage.addEventListener('pointerleave',function(){ hovering=false; });
    addEventListener('resize',function(){ if(started){ size(); seed(); if(RM) draw(); } });
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){ visible=en[0].isIntersecting; if(visible) boot(); },{threshold:.08}).observe(stage);
    } else { visible=true; boot(); }
  })();
  /* ---------- SONAR PING FX ---------- */
  function pingAt(x,y,small){
    if(RM) return;
    var count=small?2:3, base=small?.55:1;
    for(var k=0;k<count;k++){
      (function(idx){
        var d=document.createElement('div');
        d.className='sonar-fx'; d.style.left=x+'px'; d.style.top=y+'px';
        document.body.appendChild(d);
        var peak=.62-idx*.14, sc=base*(1-idx*.12);
        if(hasGSAP){
          gsap.fromTo(d,{scale:0,opacity:peak},{scale:sc,opacity:0,duration:1.3,delay:idx*.15,ease:'power2.out',
            onComplete:function(){ d.remove(); }});
        } else {
          d.style.transition='transform 1.2s cubic-bezier(.22,.61,.36,1),opacity 1.2s linear';
          d.style.opacity=peak;
          requestAnimationFrame(function(){ d.style.transform='scale('+sc+')'; d.style.opacity='0'; });
          setTimeout(function(){ d.remove(); },1400);
        }
      })(k);
    }
  }
  function pingAtCart(){
    var b=document.getElementById('cartBtn');
    if(!b){ pingAt(innerWidth-60,60,true); return; }
    var r=b.getBoundingClientRect();
    pingAt(r.left+r.width/2,r.top+r.height/2,true);
  }

  /* ---------- HERO INTRO ---------- */
  function heroIntro(){
    if(!hasGSAP || RM){
      document.querySelectorAll('#hero .ll').forEach(function(e){ e.style.transform='none'; });
      return;
    }
    var tl=gsap.timeline({defaults:{ease:'power4.out'}});
    tl.to('#hero .ll',{yPercent:0,duration:1.15,stagger:.11},0)
      .to('[data-hero]',{opacity:1,y:0,duration:.85,stagger:.09,ease:'power2.out'},.35)
      .to('.hero-stage',{opacity:1,y:0,duration:1.1,ease:'power3.out'},.3);
    pingAt(innerWidth*.78,innerHeight*.42,true);
  }

  /* ---------- HEADLINES + REVEALS + SECTION CHOREOGRAPHY ---------- */
  function splitLines(el){
    if(hasSplit){ try{ return new SplitText(el,{type:'lines,words',linesClass:'sl-line'}); }catch(e){} }
    return null;
  }
  if(hasST && !RM){
    gsap.utils.toArray('.splith').forEach(function(h){
      var s=splitLines(h);
      var targets=s?s.lines:[h];
      if(s){ targets.forEach(function(l){ var w=document.createElement('span'); w.className='mask-line';
        l.parentNode.insertBefore(w,l); w.appendChild(l); }); }
      gsap.from(targets,{yPercent:s?116:0,opacity:s?1:0,y:s?0:26,duration:1,ease:'power4.out',stagger:.1,
        scrollTrigger:{trigger:h,start:'top 86%'}});
    });
    gsap.utils.toArray('.sec-num,.eyebrow,.lead,.mock-note').forEach(function(el){
      gsap.from(el,{opacity:0,y:18,duration:.8,ease:'power2.out',scrollTrigger:{trigger:el,start:'top 92%'}});
    });

    // selling points file in
    gsap.from('[data-point]',{y:30,opacity:0,duration:.8,ease:'power2.out',stagger:.12,
      scrollTrigger:{trigger:'.points-row',start:'top 88%'}});

    // product cards: staggered reveal with a media wipe
    gsap.utils.toArray('#grid .product-card').forEach(function(card,i){
      var tl=gsap.timeline({scrollTrigger:{trigger:card,start:'top 92%'}});
      tl.from(card,{y:44,opacity:0,duration:.85,ease:'power3.out',delay:(i%4)*.06},0)
        .from(card.querySelector('.pc-visual'),{scale:1.14,opacity:.2,duration:1.1,ease:'power2.out'},0)
        .from(card.querySelectorAll('.pc-type,.pc-name,.pc-spec,.pc-foot'),{y:14,opacity:0,duration:.6,stagger:.06,ease:'power2.out'},.2);
      var badge=card.querySelector('.pc-badge');
      if(badge) tl.from(badge,{scale:.5,opacity:0,duration:.5,ease:'back.out(2)'},.42);
    });
    // filter chips pop
    gsap.from('.fchip',{y:14,opacity:0,duration:.5,stagger:.05,ease:'power2.out',
      scrollTrigger:{trigger:'.filters',start:'top 94%'}});

    // story vault stage rises, floor settles
    gsap.from('#vaultStage',{y:52,opacity:0,duration:1.1,ease:'power3.out',
      scrollTrigger:{trigger:'#vaultStage',start:'top 88%'}});
    gsap.to('#vaultStage .floor',{yPercent:-8,ease:'none',
      scrollTrigger:{trigger:'#story',start:'top bottom',end:'bottom top',scrub:true}});

    // the sounding line draws down the standard ladder
    gsap.to('.zline',{scaleY:1,ease:'none',
      scrollTrigger:{trigger:'.zones',start:'top 82%',end:'bottom 62%',scrub:true}});
    gsap.utils.toArray('.zrow').forEach(function(row){
      gsap.from(row,{x:-30,opacity:0,duration:.85,ease:'power2.out',scrollTrigger:{trigger:row,start:'top 92%'}});
    });

    // documentation panel
    gsap.from('#lotPanel',{y:40,opacity:0,duration:1,ease:'power3.out',
      scrollTrigger:{trigger:'#lotPanel',start:'top 88%'}});
    gsap.from('.lot-fields > div',{y:16,opacity:0,duration:.6,stagger:.07,ease:'power2.out',
      scrollTrigger:{trigger:'.lot-fields',start:'top 90%'}});

    // reviews: stars pop, bars fill, quotes rise
    gsap.from('#starRow svg',{scale:0,opacity:0,duration:.6,stagger:.09,ease:'back.out(2.4)',
      scrollTrigger:{trigger:'#starRow',start:'top 92%'}});
    gsap.utils.toArray('#barGroup .bar i').forEach(function(b,i){
      var pct=(parseFloat(b.getAttribute('data-pct'))||0)/100;
      gsap.fromTo(b,{scaleX:0},{scaleX:pct,duration:1.1,ease:'power3.out',delay:i*.08,
        scrollTrigger:{trigger:'#barGroup',start:'top 90%'}});
    });
    gsap.from('.tq',{y:36,opacity:0,duration:.85,stagger:.12,ease:'power2.out',
      scrollTrigger:{trigger:'.quotes',start:'top 88%'}});
    gsap.from('.press span',{y:14,opacity:0,duration:.5,stagger:.06,ease:'power2.out',
      scrollTrigger:{trigger:'.press',start:'top 94%'}});
    // stat counters
    gsap.utils.toArray('#statStrip .v').forEach(function(m){
      var target=parseFloat(m.getAttribute('data-count'))||0, suffix=m.getAttribute('data-suffix')||'', o={v:0};
      ScrollTrigger.create({trigger:m,start:'top 92%',once:true,onEnter:function(){
        gsap.to(o,{v:target,duration:1.6,ease:'power2.out',onUpdate:function(){
          m.textContent=Math.round(o.v).toLocaleString('en-US')+suffix;
        }});
      }});
    });

    // collections tiles: alternating rise with inner art counter-parallax
    gsap.utils.toArray('.coll .tile').forEach(function(t,i){
      gsap.from(t,{y:46,opacity:0,duration:.9,ease:'power3.out',delay:(i%2)*.08,
        scrollTrigger:{trigger:t,start:'top 90%'}});
      var art=t.querySelector('.art');
      if(art) gsap.fromTo(art,{yPercent:-5},{yPercent:5,ease:'none',
        scrollTrigger:{trigger:t,start:'top bottom',end:'bottom top',scrub:true}});
    });

    // faq + signup
    gsap.from('#qa .qitem',{y:20,opacity:0,duration:.65,stagger:.07,ease:'power2.out',
      scrollTrigger:{trigger:'#qa',start:'top 88%'}});
    gsap.fromTo('.signup .glowbg',{scale:.7},{scale:1.15,ease:'none',
      scrollTrigger:{trigger:'#signup',start:'top bottom',end:'bottom top',scrub:true}});
    gsap.from('.disclaimer-box',{y:24,opacity:0,duration:.9,ease:'power2.out',
      scrollTrigger:{trigger:'.disclaimer-box',start:'top 92%'}});

    // footer showpiece
    ScrollTrigger.create({trigger:'#footer',start:'top 62%',onEnter:function(){
      var f=document.getElementById('footer'); if(f) f.classList.add('lit');
    }});
    gsap.from('footer .bigtype',{yPercent:22,ease:'none',
      scrollTrigger:{trigger:'#footer',start:'top bottom',end:'bottom bottom',scrub:true}});
    gsap.from('footer .fcol',{y:26,opacity:0,duration:.8,stagger:.08,ease:'power2.out',
      scrollTrigger:{trigger:'footer .fgrid',start:'top 92%'}});

    // sonar ping on section entry, the station answering
    gsap.utils.toArray('main section').forEach(function(sec){
      ScrollTrigger.create({trigger:sec,start:'top 58%',onEnter:function(){ pingAtCart(); }});
    });

    // marquee leans with scroll velocity
    var band=document.getElementById('bandTrack');
    if(band){ var skew=0;
      gsap.ticker.add(function(){
        var t=Math.max(-40,Math.min(40,scrollVel.v))*.03;
        skew+=(t-skew)*.08;
        band.style.transform=Math.abs(skew)<.01?'':'skewX('+skew.toFixed(3)+'deg)';
      });
    }
  }

  /* ---------- ANNOUNCEMENT BAR SWAP ---------- */
  (function announce(){
    var stack=document.getElementById('annStack');
    if(!stack || !hasGSAP || RM) return;
    var slides=stack.querySelectorAll('.ann-slide').length - 1;
    if(slides<1) return;
    var idx=0;
    setInterval(function(){
      if(document.hidden) return;
      idx++;
      gsap.to(stack,{yPercent:-(100/(slides+1))*idx,duration:.75,ease:'power3.inOut',
        onComplete:function(){
          if(idx>=slides){ idx=0; gsap.set(stack,{yPercent:0}); }
        }});
    },4200);
  })();

  /* ---------- CART, QUICK ADD, QUICK LOOK ---------- */
  (function store(){
    var count=0;
    var badge=document.getElementById('cartCount');
    var cartBtn=document.getElementById('cartBtn');
    function bump(){
      count++;
      if(badge){
        badge.textContent=count;
        badge.classList.remove('zero');
        if(hasGSAP && !RM) gsap.fromTo(badge,{scale:.4},{scale:1,duration:.6,ease:'back.out(3)'});
      }
      if(cartBtn && hasGSAP && !RM) gsap.fromTo(cartBtn,{y:-4},{y:0,duration:.5,ease:'elastic.out(1,.4)'});
      pingAtCart();
    }
    function fly(from){
      if(!cartBtn || RM || !hasGSAP){ bump(); return; }
      var a=from.getBoundingClientRect(), b=cartBtn.getBoundingClientRect();
      var d=document.createElement('div');
      d.className='fly-dot';
      d.style.left=(a.left+a.width/2)+'px';
      d.style.top=(a.top+a.height/2)+'px';
      document.body.appendChild(d);
      var dx=(b.left+b.width/2)-(a.left+a.width/2), dy=(b.top+b.height/2)-(a.top+a.height/2);
      gsap.timeline({onComplete:function(){ d.remove(); bump(); }})
        .to(d,{x:dx*.55,y:dy*.55-70,duration:.42,ease:'power2.out'},0)
        .to(d,{x:dx,y:dy,duration:.44,ease:'power2.in'},.42)
        .to(d,{scale:.3,opacity:0,duration:.3,ease:'power2.in'},.62);
    }
    document.querySelectorAll('#grid .pc-cta').forEach(function(btn){
      btn.addEventListener('click',function(){
        fly(btn);
        btn.classList.add('added');
        var label=btn.textContent;
        btn.textContent='Added';
        setTimeout(function(){ btn.classList.remove('added'); btn.textContent=label; },1400);
      });
    });
    document.querySelectorAll('#grid .pc-quick').forEach(function(btn){
      btn.addEventListener('click',function(){
        var card=btn.closest('.product-card');
        if(!card) return;
        var open=card.classList.contains('pc-open');
        document.querySelectorAll('#grid .product-card').forEach(function(c){ c.classList.remove('pc-open'); });
        if(!open) card.classList.add('pc-open');
      });
    });
    ['searchBtn','acctBtn','cartBtn'].forEach(function(id){
      var el=document.getElementById(id);
      if(el) el.addEventListener('click',function(){ pingAtCart(); });
    });
  })();

  /* ---------- FILTER CHIPS ---------- */
  (function filters(){
    var chips=document.querySelectorAll('.fchip');
    var cards=document.querySelectorAll('#grid .product-card');
    if(!chips.length || !cards.length) return;
    chips.forEach(function(chip){
      chip.addEventListener('click',function(){
        var f=chip.getAttribute('data-filter');
        chips.forEach(function(c){ c.setAttribute('aria-pressed', c===chip ? 'true':'false'); });
        var shown=[];
        cards.forEach(function(card){
          var match = (f==='all') || card.getAttribute('data-cat')===f;
          card.classList.remove('pc-open');
          card.style.display = match ? '' : 'none';
          if(match) shown.push(card);
        });
        if(hasGSAP && !RM && shown.length){
          gsap.fromTo(shown,{y:22,opacity:0,scale:.985},
            {y:0,opacity:1,scale:1,duration:.6,ease:'power3.out',stagger:.05,overwrite:'auto',clearProps:'transform'});
        }
        if(hasST) ScrollTrigger.refresh();
      });
    });
  })();

  /* ---------- THE VAULT: light cone, proximity lighting, seabed dust ---------- */
  (function vault(){
    var stage=document.getElementById('vaultStage'), cone=document.getElementById('lightCone');
    if(!stage || !cone) return;
    var items=stage.querySelectorAll('.vault-items .vv');
    if(RM){
      cone.style.opacity='.45'; cone.style.left='28%'; cone.style.top='36%';
      return;
    }
    var tx=0,ty=0,cx=0,cy=0,half=235,hovering=false;
    function measure(){ half=(cone.offsetWidth||470)/2; }
    addEventListener('resize',measure);
    stage.addEventListener('pointermove',function(e){
      var r=stage.getBoundingClientRect();
      tx=e.clientX-r.left; ty=e.clientY-r.top; hovering=true;
    });
    stage.addEventListener('pointerleave',function(){ hovering=false; });
    var dcv=document.getElementById('vaultDust'), dctx=null, dparts=[], DW=0, DH=0, lit=0, wasLit=false, visible=false;
    function dresize(){
      if(!dcv) return;
      var r=stage.getBoundingClientRect();
      DW=dcv.width=Math.max(2,Math.round(r.width*DPR));
      DH=dcv.height=Math.max(2,Math.round(r.height*DPR));
    }
    function dust(n,bx,by,burst){
      for(var i=0;i<n;i++){
        if(dparts.length>140) return;
        dparts.push({x:bx+(Math.random()-.5)*60*DPR,y:by+(Math.random()-.5)*14*DPR,
          vx:(Math.random()-.5)*(burst?.5:.08)*DPR, vy:-(Math.random()*(burst?.5:.12)+.03)*DPR,
          r:(Math.random()*1.6+.5)*DPR, a:Math.random()*.3+.1, life:1, decay:burst?.006:.002});
      }
    }
    function seed(){ dparts.length=0; for(var i=0;i<40;i++) dust(1,Math.random()*DW,DH*(.62+Math.random()*.3),false); }
    function billow(){
      var sr=stage.getBoundingClientRect();
      items.forEach(function(v){
        var vr=v.getBoundingClientRect();
        dust(12,(vr.left-sr.left+vr.width/2)*DPR,(vr.bottom-sr.top-8)*DPR,true);
      });
    }
    function initDust(){ if(dctx || !dcv) return; dctx=dcv.getContext('2d'); dresize(); seed(); measure(); }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){ visible=en[0].isIntersecting; if(visible) initDust(); },{threshold:.14}).observe(stage);
    } else { initDust(); visible=true; }
    addEventListener('resize',function(){ if(dctx) dresize(); });
    (function loop(){
      requestAnimationFrame(loop);
      if(!visible || document.hidden) return;
      cx+=(tx-cx)*.08; cy+=(ty-cy)*.08;
      cone.style.transform='translate('+(cx-half).toFixed(1)+'px,'+(cy-half).toFixed(1)+'px)';
      var target=(hovering||stage.classList.contains('auto'))?1:0;
      lit+=(target-lit)*.05;
      if(target===1 && !wasLit && dctx) billow();
      wasLit=target===1;
      var sr=stage.getBoundingClientRect();
      items.forEach(function(v){
        var vr=v.getBoundingClientRect();
        var vx=vr.left-sr.left+vr.width/2, vy=vr.top-sr.top+vr.height/2;
        var b=Math.max(0,1-Math.hypot(vx-cx,vy-cy)/(sr.width*.36))*lit;
        var gl=v.querySelector('.vglow'); if(gl) gl.style.opacity=(b*.9).toFixed(3);
        var sv=v.querySelector('svg'); if(sv) sv.style.opacity=(.5+b*.5).toFixed(3);
        var cp=v.querySelector('.cap'); if(cp) cp.style.opacity=(.42+b*.58).toFixed(3);
      });
      if(dctx){
        dctx.clearRect(0,0,DW,DH);
        if(dparts.length<40 && Math.random()<.3) dust(1,Math.random()*DW,DH*(.65+Math.random()*.3),false);
        dctx.fillStyle='rgba(160,220,230,1)';
        for(var i=dparts.length-1;i>=0;i--){
          var p=dparts[i];
          p.x+=p.vx; p.y+=p.vy; p.vy*=.995; p.life-=p.decay;
          if(p.life<=0 || p.y<-10){ dparts.splice(i,1); continue; }
          dctx.globalAlpha=p.a*p.life*(.25+lit*.75);
          dctx.beginPath(); dctx.arc(p.x,p.y,p.r,0,6.283); dctx.fill();
        }
        dctx.globalAlpha=1;
      }
    })();
    if(hasST){
      ScrollTrigger.create({trigger:stage,start:'top 68%',once:true,onEnter:function(){
        initDust();
        stage.classList.add('auto');
        var r=stage.getBoundingClientRect();
        tx=r.width*.12; ty=r.height*.5; cx=tx; cy=ty;
        var o={p:0};
        gsap.to(o,{p:1,duration:4,ease:'power1.inOut',
          onUpdate:function(){ if(hovering) return;
            tx=r.width*(.12+.76*o.p); ty=r.height*(.5+.06*Math.sin(o.p*Math.PI*2)); },
          onComplete:function(){ stage.classList.remove('auto'); }});
        pingAtCart();
      }});
    }
    if(window.matchMedia && window.matchMedia('(hover:none)').matches){
      stage.classList.add('auto');
      var ang=0;
      setInterval(function(){
        if(!visible || document.hidden) return;
        ang+=.02;
        var r=stage.getBoundingClientRect();
        tx=r.width*(.5+.3*Math.cos(ang)); ty=r.height*(.5+.18*Math.sin(ang));
      },80);
    }
  })();

  /* ---------- LOT LOOKUP PANEL (demo) ---------- */
  (function lots(){
    var chips=document.querySelectorAll('.lot-chip');
    var code=document.getElementById('lotCode'), purity=document.getElementById('lotPurity'),
        method=document.getElementById('lotMethod'), lab=document.getElementById('lotLab'),
        date=document.getElementById('lotDate'), witness=document.getElementById('lotWitness'),
        scan=document.getElementById('scanline'), btn=document.getElementById('lotBtn'),
        input=document.getElementById('lotInput'), panel=document.getElementById('lotPanel');
    if(!chips.length || !code) return;
    var data=[
      {c:'HDL-GHK-01 / L2411',p:99.2,m:'RP-HPLC / MS',l:'Accredited, ISO 17025',d:'2026.04.11',w:'Retained 24 mo'},
      {c:'HDL-A1MQ-02 / L2408',p:98.7,m:'RP-HPLC / NMR',l:'Accredited, ISO 17025',d:'2026.02.27',w:'Retained 24 mo'},
      {c:'HDL-GHK-01B / L2503',p:99.4,m:'RP-HPLC / MS',l:'Accredited, ISO 17025',d:'2026.06.02',w:'Retained 36 mo'}
    ];
    function show(i){
      var d=data[i]; if(!d) return;
      code.textContent=d.c; method.textContent=d.m; lab.textContent=d.l;
      date.textContent=d.d; witness.textContent=d.w;
      if(hasGSAP && !RM){
        var o={v:0};
        gsap.to(o,{v:d.p,duration:1,ease:'power2.out',onUpdate:function(){ purity.textContent=o.v.toFixed(1)+'%'; }});
        if(scan && panel){
          gsap.fromTo(scan,{opacity:.9,y:0},{opacity:0,y:panel.offsetHeight,duration:1,ease:'power1.inOut'});
        }
      } else {
        purity.textContent=d.p.toFixed(1)+'%';
      }
    }
    chips.forEach(function(chip,i){
      chip.addEventListener('click',function(){
        chips.forEach(function(c){ c.setAttribute('aria-pressed', c===chip ? 'true':'false'); });
        show(i);
      });
    });
    if(btn) btn.addEventListener('click',function(){
      var v=(input && input.value ? input.value : '').trim();
      var hit=0;
      for(var i=0;i<data.length;i++){ if(v && data[i].c.toLowerCase().indexOf(v.toLowerCase())>-1) hit=i; }
      chips.forEach(function(c,ci){ c.setAttribute('aria-pressed', ci===hit ? 'true':'false'); });
      show(hit);
    });
    if(hasST){
      ScrollTrigger.create({trigger:'#lotPanel',start:'top 78%',once:true,onEnter:function(){ show(0); }});
    } else { show(0); }
  })();

  /* ---------- FAQ ACCORDION ---------- */
  document.querySelectorAll('#qa .qitem').forEach(function(item){
    var btn=item.querySelector('button'), ans=item.querySelector('.ans');
    if(!btn || !ans) return;
    btn.addEventListener('click',function(){
      var open=item.classList.contains('open');
      document.querySelectorAll('#qa .qitem').forEach(function(o){
        o.classList.remove('open');
        var a=o.querySelector('.ans'); if(a) a.style.maxHeight='0';
      });
      if(!open){ item.classList.add('open'); ans.style.maxHeight=ans.scrollHeight+'px'; }
      if(hasST) ScrollTrigger.refresh();
    });
  });

  /* ---------- NEWSLETTER MOCKS ---------- */
  [['mailBtn','mailInput'],['footMailBtn','footMail']].forEach(function(pair){
    var b=document.getElementById(pair[0]), f=document.getElementById(pair[1]);
    if(!b) return;
    b.addEventListener('click',function(){
      var label=b.textContent;
      b.textContent='Demo only';
      if(f) f.value='';
      pingAtCart();
      setTimeout(function(){ b.textContent=label; },1500);
    });
  });
  /* ---------- EASTER EGGS ---------- */
  function revealEyes(){
    ['vaultEyes1','vaultEyes2'].forEach(function(id){
      var el=document.getElementById(id); if(!el) return;
      el.style.opacity='1';
      setTimeout(function(){ el.style.opacity='0'; },1600);
    });
  }
  document.querySelectorAll('[data-egg]').forEach(function(el){
    el.addEventListener('click',function(e){
      var kind=el.getAttribute('data-egg');
      if(kind==='angler' || kind==='footer'){ e.preventDefault(); }
      pingAt(e.clientX,e.clientY,false);
      revealEyes();
    });
  });
  var buf='';
  addEventListener('keydown',function(e){
    if(!e.key || e.key.length>1) return;
    buf=(buf+e.key).slice(-4).toLowerCase();
    if(buf==='dive'){
      var v=document.getElementById('story');
      if(v){
        if(lenis) lenis.scrollTo(v,{duration:2.4});
        else v.scrollIntoView({behavior:'smooth'});
        pingAt(innerWidth/2,innerHeight/2,false);
        revealEyes();
      }
    }
  });

  /* ---------- REFRESH HOOKS ---------- */
  if(hasST){
    setTimeout(function(){ ScrollTrigger.refresh(); },420);
    window.addEventListener('load',function(){ ScrollTrigger.refresh(); });
    if(document.fonts && document.fonts.ready && document.fonts.ready.then){
      document.fonts.ready.then(function(){ ScrollTrigger.refresh(); });
    }
  }
})();

(function(){
  'use strict';
  var q=function(s,r){return (r||document).querySelector(s)};
  var qa=function(s,r){return Array.from((r||document).querySelectorAll(s))};
  function lock(v){document.documentElement.classList.toggle('modal-open',v);document.body.classList.toggle('modal-open',v)}
  function focusables(el){return qa('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',el)}
  function trap(e,el){if(e.key!=='Tab')return;var f=focusables(el);if(!f.length)return;var a=f[0],z=f[f.length-1];if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus()}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus()}}
  function initHeader(root){
    var h=q('[data-hadal-header]',root||document);if(!h||h.dataset.ready)return;h.dataset.ready='1';
    var open=q('[data-drawer-open]',h),drawer=q('[data-drawer]',h),back=q('[data-drawer-backdrop]',h),close=q('[data-drawer-close]',h),last=null;
    function setDrawer(v){if(!drawer)return;drawer.classList.toggle('is-open',v);back&&back.classList.toggle('is-open',v);drawer.setAttribute('aria-hidden',String(!v));open&&open.setAttribute('aria-expanded',String(v));lock(v);if(v){last=document.activeElement;setTimeout(()=>q('a,button',drawer)?.focus(),40)}else last&&last.focus()}
    open&&open.addEventListener('click',()=>setDrawer(true));close&&close.addEventListener('click',()=>setDrawer(false));back&&back.addEventListener('click',()=>setDrawer(false));qa('a',drawer).forEach(a=>a.addEventListener('click',()=>setDrawer(false)));drawer&&drawer.addEventListener('keydown',e=>trap(e,drawer));
    var so=q('[data-search-open]',h),sm=q('[data-search-modal]',h),sc=q('[data-search-close]',h),sb=q('[data-search-backdrop]',h),slast=null;
    function setSearch(v){if(!sm)return;sm.classList.toggle('is-open',v);sm.setAttribute('aria-hidden',String(!v));lock(v);if(v){slast=document.activeElement;setTimeout(()=>q('input',sm)?.focus(),40)}else slast&&slast.focus()}
    so&&so.addEventListener('click',()=>setSearch(true));sc&&sc.addEventListener('click',()=>setSearch(false));sb&&sb.addEventListener('click',()=>setSearch(false));sm&&sm.addEventListener('keydown',e=>trap(e,sm));
    document.addEventListener('keydown',e=>{if(e.key==='Escape'){setDrawer(false);setSearch(false)}});
  }
  function initGallery(root){qa('[data-product-gallery]',root||document).forEach(function(g){if(g.dataset.ready)return;g.dataset.ready='1';var main=q('[data-gallery-main]',g);qa('[data-gallery-thumb]',g).forEach(function(b){b.addEventListener('click',function(){var u=b.dataset.imageUrl||'',ss=b.dataset.imageSrcset||'',a=b.dataset.imageAlt||'';if(main&&u){main.removeAttribute('srcset');main.src=u;if(ss)main.setAttribute('srcset',ss);main.alt=a;}qa('[data-gallery-thumb]',g).forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-pressed','false')});b.classList.add('is-active');b.setAttribute('aria-pressed','true')})})})}
  function initQty(root){qa('[data-qty]',root||document).forEach(w=>{if(w.dataset.ready)return;w.dataset.ready='1';var i=q('input',w);qa('button',w).forEach(b=>b.addEventListener('click',()=>{var n=Math.max(1,parseInt(i.value||1,10)+(b.dataset.qtyAction==='plus'?1:-1));i.value=n;i.dispatchEvent(new Event('change',{bubbles:true}))}))})}
  function initShelf(root){qa('[data-shelf]',root||document).forEach(s=>{if(s.dataset.ready)return;s.dataset.ready='1';qa('[data-filter]',s).forEach(b=>b.addEventListener('click',()=>{var f=b.dataset.filter;qa('[data-filter]',s).forEach(x=>{x.classList.toggle('on',x===b);x.setAttribute('aria-pressed',String(x===b))});qa('[data-cat]',s).forEach(c=>{c.hidden=!(f==='all'||c.dataset.cat===f)});if(window.ScrollTrigger)requestAnimationFrame(()=>ScrollTrigger.refresh())}))})}
  function initCart(root){
    /* Add to cart + toast now live in assets/lexar-commerce.js */
  }
  function initAll(root){initHeader(root);initGallery(root);initQty(root);initShelf(root);if(window.ScrollTrigger)requestAnimationFrame(()=>ScrollTrigger.refresh())}
  document.addEventListener('DOMContentLoaded',()=>{initAll(document);initCart(document)});
  document.addEventListener('shopify:section:load',e=>initAll(e.target));
})();
/* Mobile-adaptive canvases v2: phones change layout boxes after first paint
   (font load, URL-bar collapse, aspect-ratio media flips) without always
   firing a window resize. Watch each canvas's own box and replay the theme's
   resize path ONLY when the box genuinely changed — several heroes rebuild
   and replay their intro on resize, so a synthetic ping on load or on the
   observer's first callback would visibly restart them. */
(function () {
  if (!('ResizeObserver' in window)) return;
  var last = new WeakMap();
  var t;
  function ping() { clearTimeout(t); t = setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 120); }
  var ro = new ResizeObserver(function (entries) {
    var changed = false;
    entries.forEach(function (en) {
      var r = en.target.getBoundingClientRect();
      var p = last.get(en.target);
      last.set(en.target, { w: r.width, h: r.height });
      if (p && (Math.abs(p.w - r.width) > 1 || Math.abs(p.h - r.height) > 1)) changed = true;
    });
    if (changed) ping();
  });
  function watch() { document.querySelectorAll('canvas').forEach(function (c) { ro.observe(c); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  window.addEventListener('orientationchange', function () { setTimeout(ping, 200); });
})();
